
import {defaults,pick} from 'underscore';
import * as globalisation from './globalisation';
import mediator from '../js/mediator';
import config from '../js/config';
import { EnableAdobeAnalytics } from '../utilities/featureFlags';

const DEFAULT_ERROR = {
  level: 'Error',
  type: null,
  title: '',
  messages: null
};

export function getMergedError(error) {
  if (!DEFAULT_ERROR.title) {
    try {
      DEFAULT_ERROR.title = globalisation.pluraliseAndTranslate('commonValidation', 'defaultErrorMessage');
    } catch (error) {
      DEFAULT_ERROR.title = 'Sorry, there has been an error.';
    }
  }
  return {
    ...DEFAULT_ERROR,
    messages: [],
    ...error
  };
}

export function getErrorFromXHR(xhr) {
  let error = xhr && xhr.responseJSON ? xhr.responseJSON.error : null;
  if (EnableAdobeAnalytics.isEnabled()) {
    let error_messages = [];
    error.messages.forEach(msg => {
      error_messages.push({
        error_message: msg.message || undefined
      });
    });
    window.adobeDataLayer.push({
      event: 'api_error',
      error_messages: error_messages,
      responseCode: xhr.status.toString() || undefined
    });
  }
  return getMergedError(error);
}

/**
 * @param {Error} jsError A native JavaScript error thrown from middleware
 * @param errorProperties Properties based on DEFAULT_ERROR
 * @return {*}
 */
export function fillErrorInstance(jsError, errorProperties) {
  if (!jsError) return;
  let pickedProperties = pick(errorProperties, [
    'level',
    'type',
    'title',
    'messages'
  ]);
  defaults(jsError, pickedProperties, DEFAULT_ERROR);
  return jsError;
}

export function globalErrorHandler(error) {
  // Fix for navigation triggering ajax errors in FF
  if (config.isNavigatingAway) {
    return;
  }

  // Trigger the appropriate error event
  var errorEvent = config.events.error[error.type] || config.events.error.generic;
  mediator.trigger(errorEvent, { error });
}

export function globalAjaxErrorHandler(e, $xhr, settings) {
  // Fix for navigation triggering ajax errors in FF
  if (config.isNavigatingAway) {
    return;
  }

  // Ignore aborted requests
  if ($xhr.statusText === 'abort') {
    return;
  }

  var response = $xhr.responseJSON;

  //Handle errors globally unless specified otherwise from the source.
  if ((settings && settings.handleErrorLocally) || ($xhr && $xhr.handleErrorLocally)) {
    return;
  }

  // Use generic error if there was no server error message
  if (!response) {
    response = {};
  }

  if (!response.error) {
    response.error = getMergedError({
      type: 'generic'
    });
  }

  if (EnableAdobeAnalytics.isEnabled()) {
    if (response.error.messages.length === 0) {
      window.adobeDataLayer.push({
        event: 'api_error',
        error_messages: [{
          error_message: globalisation.pluraliseAndTranslate('commonValidation', 'defaultErrorResponse')
        }],
        responseCode: $xhr.status.toString() || undefined
      });
    } else if (response.error.messages.length > 0) {
      let error_messages = [];
      response.error.messages.forEach(msg => {
        error_messages.push({
          error_message: msg.message || undefined
        });
      });
      window.adobeDataLayer.push({
        event: 'api_error',
        error_messages: error_messages,
        responseCode: $xhr.status.toString() || undefined
      });
    }
  }
  // Trigger the appropriate error event
  var errorEvent = config.events.error[response.error.type] || config.events.error.generic;
  mediator.trigger(errorEvent, response);
}




// WEBPACK FOOTER //
// ./assets/utilities/errorHandling.js